export default "__VITE_ASSET__DwU$jBGK__"